import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts from "@material-ui/core/es/styles/withStyles";
import {COLOR_chart_barra_serie_0} from "../../../common/CustomTheme/grayyellow/colors";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


var config = {
        chart: {
            type: 'column',
            zoomType: 'x'
        },
        legend: {
            enabled: true
        },
        title: {
            text: 'Bandas'
        },
        xAxis: {
            categories: [],
            title: {
                text: ''
            }
        },
        plotOptions: {
            pareto: {
                marker: {
                    enabled: false
                }
            },
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    color: 'blue',
                    format: '{point.y:.0f}',
                    rotation: 270
                }
            }
        },
        yAxis: [{
            title: {
                text: ''
            }
        }, {
            title: {
                text: ''
            },
            minPadding: 0,
            maxPadding: 0,
            max: 100,
            min: 0,
            opposite: true,
            labels: {
                format: "{value}%"
            }
        }],
        series: [{
            type: 'pareto',
            name: 'Pareto',
            yAxis: 1,
            zIndex: 10,
            baseSeries: 1
        }, {
            type: 'column',
            zIndex: 2,
            name: 'Banda',
            data: []
        }]
    };


export default function TireBandsParetoChart(prop) {
    const { series } = prop;

    if (series) {
        let categories = [];
        let bTotal = [];

        series.map(i => {
            categories.push(i.banda);
            bTotal.push( i.total );

        })

        config = {
            ...config,
            xAxis: {
                categories: categories,
                title: {
                    text: ''
                }
            },

            series: [{
                type: 'pareto',
                name: 'Pareto',
                yAxis: 1,
                zIndex: 10,
                baseSeries: 1
            }, {
                type: 'column',
                zIndex: 2,
                name: 'Banda',
                data: bTotal,
                color: COLOR_chart_barra_serie_0
            }]
        }

    }


    return (
        <Card>
            <ReactHighcharts config = {config}>
            </ReactHighcharts>
        </Card>
    )
}
